export const isEmbeddedFromLocalStorageAndTopUrl = (): boolean => {
  const isIframe = window.self !== window.top;
  return isIframe;
};
